import Decimal from 'decimal.js';

export const divide = (value: number, divider: number): number => {
  return new Decimal(value).div(divider).toNumber();
};

export const getDecimalToPercentage = (value: number): number => {
  return new Decimal(value).mul(100).toNumber();
};

export const getRoundedDecimal = (value: number): number => {
  Decimal.set({ rounding: 1 });
  return new Decimal(value).times(100).ceil().dividedBy(100).toNumber();
};

export const calculateUsersInConversion = (totalUsers: number, conversionRate: number): number => {
  return new Decimal(totalUsers).mul(conversionRate).div(100).toNumber();
};

export const nullableNumberToString = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) return '';
  return value.toString();
};

export function generateRandomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * @deprecated use round() from lodash instead
 * @param value
 * @param decimals
 */
export function roundNumber(value: number, decimals: number) {
  return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
}

export const calcPercentageDiff = (val1?: number, val2?: number) => {
  if (!val1 && !val2) return 0;
  if (!val2) return null;
  if (!val1 && val2) return 0;
  if (val1 === val2) return 0;
  return ((val1 ?? 0) - (val2 ?? 0)) / val2!;
};

export function mathematicallyAccuratePercentageDiff(current: number, previous: number) {
  const absDiff = Math.abs(current - previous);
  const halfSum = (current + previous) / 2;
  const agg = absDiff / halfSum;
  return agg * 100 * Math.sign(current - previous);
}

export const calcPercentage = (val1?: number, val2?: number) => {
  if (!val1 && !val2) return 0;
  if (!val2) return 1;
  if (!val1 && val2) return 0;
  return (val1 ?? 0) / val2!;
};
